import {
  AuthFlowComplete,
  AuthFlowId,
  AuthStepDefinition,
  AuthStepId,
  AuthStepRoute,
  AuthTransitionKey,
} from '../../models/auth-flow.models';

export const PVZ_SUBSTITUTE_STEP: AuthStepDefinition = {
  id: AuthStepId.ENTER_ON_PVZ_LINK_UNKNOWN_USER,
  route: AuthStepRoute.Substitute,
  back: AuthStepId.ENTER_ON_PVZ_LINK,
  showLegalFooter: true,
  next: {
    [AuthFlowId.Pvz]: {
      [AuthTransitionKey.Default]: AuthFlowComplete.Complete,
    },
  },
};
